import { render } from "./InventoryList.vue?vue&type=template&id=60c6f4af&scoped=true"
import script from "./InventoryList.vue?vue&type=script&lang=js"
export * from "./InventoryList.vue?vue&type=script&lang=js"

import "./InventoryList.vue?vue&type=style&index=0&id=60c6f4af&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c6f4af"]])

export default __exports__